import FormulaEditor from 'pages/AIMusicGenerator/components/FormulaEditor';
import FormulaFieldsSwitch from 'pages/AIMusicGenerator/components/FormulaFieldsSwitch';
import MobileInfoGuide from 'pages/AIMusicGenerator/components/InfoGuide/MobileInfoGuide/MobileInfoGuide';
import useDrawerState from 'pages/AIMusicGenerator/components/MobileFormulaDrawer/useDrawerState';
import useFormulaSubmit from '../../../useFormulaSubmit';
import GenerateButton from '../../GenerateButton';
import PromptTypeToggle from '../../PromptTypeToggle';
import { UserLoop } from '../../UserLoop';
import {
  ButtonContainer,
  Container,
  FormulaFieldsSwitchContainer,
  StyledFooter,
  StyledOuterContainer,
} from './styled';

const MobileAdvancedFormulaPanel = () => {
  const { isOpen, close } = useDrawerState();

  const submitFormula = useFormulaSubmit();

  const submitHandler = () => {
    if (isOpen) {
      close();
    }
    submitFormula();
  };

  return (
    <StyledOuterContainer>
      <Container>
        <PromptTypeToggle />
        <UserLoop />
        <FormulaEditor />
      </Container>

      <StyledFooter>
        <FormulaFieldsSwitchContainer>
          <FormulaFieldsSwitch />
        </FormulaFieldsSwitchContainer>
        <ButtonContainer>
          <MobileInfoGuide />
          <GenerateButton onClick={submitHandler} />
        </ButtonContainer>
      </StyledFooter>
    </StyledOuterContainer>
  );
};

export default MobileAdvancedFormulaPanel;
